import fddimTheWave from "../../src/media/visual-art/fddim-coloring-pages/the wave.jpg";
import fddimTheCoder from "../../src/media/visual-art/fddim-coloring-pages/The Coder.jpg";
import fddimWallAnimals from "../../src/media/visual-art/fddim-coloring-pages/wall animals.jpg";
import fddimLeefWolf from "../../src/media/visual-art/fddim-coloring-pages/leef wolf.jpg";
import fddimTheFactory from "../../src/media/visual-art/fddim-coloring-pages/the factory.jpg";
import fddimProprioception from "../../src/media/visual-art/fddim-coloring-pages/Proprioception.jpg";
import fddimMystery from "../../src/media/visual-art/fddim-coloring-pages/Mystery.jpg";
import fddimSurprisePage from "../../src/media/visual-art/fddim-coloring-pages/Surprise Page.jpg";
import fddimRepairs from "../../src/media/visual-art/fddim-coloring-pages/repairs.jpg";
import fddimSk8dog from "../../src/media/visual-art/fddim-coloring-pages/sk8dog.jpg";
import fddimUrTurn from "../../src/media/visual-art/fddim-coloring-pages/ur turn.jpg";
import fddimTwins from "../../src/media/visual-art/fddim-coloring-pages/Twins.jpg";
import fddimShravana from "../../src/media/visual-art/fddim-coloring-pages/shravana.jpg";
import fddimSlowPicking from "../../src/media/visual-art/fddim-coloring-pages/slow picking.jpg";

export const VISUAL_ART_SOURCES = [
  {
    src: fddimTheWave,
    title: "the wave",
    description: "This one is wet, only color this page if you're ready to get soaked. Free Dimension, Did I Mention?? Coloring Page.",
    date: "2021/05/11",
    tags: ["fddim", "coloring-page"],
    width: 3391,
    height: 2198
  },
  {
    src: fddimTheCoder,
    title: "The Coder",
  description: "This is what happens to your instruments (and yes- you too!) when you nibble at the Top Cyrogentic Planetarium for your daily lunch. Free Dimension, Did I Mention?? Coloring Page.",
    date: "2021/05/11",
    tags: ["fddim", "coloring-page"],
    width: 2192,
    height: 3400
  },
  {
    src: fddimWallAnimals,
    title: "wall animals",
    description: "Communication. It's important to communicate with different species and forms of life and beyond life. Free Dimension, Did I Mention?? Coloring Page. ",
    date: "2021/05/08",
    tags: ["fddim", "coloring-page"],
    width: 900,
    height: 550
  },
  {
    src: fddimLeefWolf,
    title: "leef wolf",
    description: "feeel flow. Free Dimension, Did I Mention?? Coloring Page.",
    date: "2021/05/11",
    tags: ["fddim", "coloring-page"],
    width: 3391,
    height: 2175
  },
  {
    src: fddimTheFactory,
    title: "the factory",
    description: "pump it out. Free Dimension, Did I Mention?? Coloring Page.",
    date: "2021/05/11",
    tags: ["fddim", "coloring-page"],
    width: 3392,
    height: 2198
  },
  {
    src: fddimProprioception,
    title: "Proprioception",
    description: "can you feel it?? Free Dimension, Did I Mention?? Coloring Page.",
    date: "2021/05/11",
    tags: ["fddim", "coloring-page"],
    width: 2115,
    height: 3400
  },
  {
    src: fddimMystery,
    title: "Mystery",
    description: "swirly ones soon... Free Dimension, Did I Mention?? Coloring Page.",
    date: "2021/05/11",
    tags: ["fddim", "coloring-page"],
    width: 3400,
    height: 2083
  },
  {
    src: fddimSurprisePage,
    title: "Surprise Page",
    description: "needs to be re-uploaded!!! Free Dimension, Did I Mention?? Coloring Page.",
    date: "2021/05/11",
    tags: ["fddim", "coloring-page"],
    width: 1210,
    height: 734
  },
  {
    src: fddimRepairs,
    title: "repairs",
    description: "These mushies will fix everything. Bring that old car on back... Free Dimension, Did I Mention?? Coloring Page.",
    date: "2021/05/11",
    tags: ["fddim", "coloring-page"],
    width: 3383,
    height: 2187
  },
  {
    src: fddimSk8dog,
    title: "sk8dog",
    description: "Our shoes speak in tongues, and dinner is almost done, skating is so fun that I almost lost a thumb, eating at Wendy's. Remember that?? Free Dimension, Did I Mention?? Coloring Page.",
    date: "2021/05/11",
    tags: ["fddim", "coloring-page"],
    width: 2174,
    height: 3386
  },
  {
    src: fddimUrTurn,
    title: "ur turn",
    description: "Pick it and spin it, like sugar in the bowl, cotton candy clouds of sound, make it rain, and make it loud. Spinning vinyl for the final sea of trees, oeaniac society. Hey, here's an idea, use some of these words for your next party that has the theme of making posters for fake events and fake bands. Free Dimension, Did I Mention?? Coloring Page.",
    date: "2021/05/11",
    tags: ["fddim", "coloring-page"],
    width: 3426,
    height: 2218
  },
  {
    src: fddimTwins,
    title: "Twins",
    description: "I tried to draw some people, and they conglommerated into twins. Free Dimension, Did I Mention?? Coloring Page.",
    date: "2021/05/11",
    tags: ["fddim", "coloring-page"],
    width: 777,
    height: 1204
  },
  {
    src: fddimShravana,
    title: "shravana",
    description: "This is a nakshatra between the degrees of capricorn. Shravana is represented by the ear. So, listen up, out, and it. Free Dimension, Did I Mention?? Coloring Page.",
    date: "2021/05/11",
    tags: ["fddim", "coloring-page"],
    width: 2174,
    height: 3349
  },
  {
    src: fddimSlowPicking,
    title: "slow picking",
    description: "Sometimes you just gotta take it slow, and absorb twice more than you'd know. If you had gone a ways to the shaking of vocal plexus, a leeping larnyx will show how the anchor is resting on a pinpoint of - Go! Free Dimension, Did I Mention?? Coloring Page.",
    date: "2021/05/11",
    tags: ["fddim", "coloring-page"],
    width: 3386,
    height: 2171
  }
]